

var _validators = require('./validators');

var _util = require('../../js/lib/util.js');

var _constants = require('../../js/lib/constants');

var _logger = require('xo-beaver/dist/logger');

var _ = require('underscore/underscore.js');
// TODO: add a constants file and move all the constants to that file

module.exports = {
    validateAndGetAdditionalCharges: function validateAndGetAdditionalCharges(shoppingCart) {
        var items = shoppingCart && shoppingCart.items;
        if (!items || items.length === 0) {
            return;
        }
        var shippingProfile = shoppingCart && shoppingCart.shippingProfile;
        var additionalCharges = void 0,
            buttonShipping = void 0,
            shipping = void 0,
            tax = void 0,
            handlingCost = void 0,
            discount = void 0;

        if (items === undefined || items.length === 0) {
            return additionalCharges;
        }
        _.forEach(items, function (item) {
            if (item && +item.quantity > 0) {
                buttonShipping = sumCharge(buttonShipping, item.shipping_cost);
                if (!item.tax_rate && item.tax) {
                    tax = sumCharge(tax, (item.tax * item.quantity).toFixed(2));
                } else if (item.tax) {
                    tax = sumCharge(tax, item.tax);
                }
                handlingCost = sumCharge(handlingCost, item.handling_cost);
                discount = sumCharge(discount, item.discount);
            }
        });
        shipping = evaluateShipping(buttonShipping, shippingProfile);
        if (shoppingCart.total_handling_charges) {
            handlingCost = +shoppingCart.total_handling_charges.value || handlingCost;
        }
        additionalCharges = addCharge(additionalCharges, _constants.XCLICK_VARS.SHIPPING, shipping);
        var formattedTax = (0, _util.formatValue)(tax, 2);
        if (formattedTax) {
            formattedTax = Number(formattedTax);
            additionalCharges = addCharge(additionalCharges, _constants.XCLICK_VARS.TAX, formattedTax);
        }
        additionalCharges = addCharge(additionalCharges, _constants.XCLICK_VARS.HANDLING, handlingCost);
        if (discount) {
            if (discount < addItemAmounts(shoppingCart.items)) {
                var formattedDiscount = (0, _util.formatValue)(discount, 2);
                if (formattedDiscount) {
                    additionalCharges = addCharge(additionalCharges, _constants.XCLICK_VARS.DISCOUNT, Number(formattedDiscount));
                }
            } else {
                _logger.$logger.info('discount_exceeds_itemTotal');
            }
        }
        // total shipping and total handlingCost must be positive
        return {
            cartValid: (shipping === undefined || shipping >= 0) && (handlingCost === undefined || handlingCost >= 0),
            charges: additionalCharges
        };
    },

    getMerchantDetails: function getMerchantDetails(shoppingCart, buttonItemDetails, merchantBusinessName) {
        if (!shoppingCart) {
            return {};
        }
        var merchantDetails = {
            imageUrl: shoppingCart && shoppingCart.urls && shoppingCart.urls.image_url,
            merchant_email: buttonItemDetails && buttonItemDetails.payee && buttonItemDetails.payee.email
        };
        merchantDetails.brand_name = merchantBusinessName ? merchantBusinessName : merchantDetails.merchant_email;
        return merchantDetails;
    },

    getItemsForCheckout: function getItemsForCheckout(itemList) {
        var updatedList = [];
        if (itemList && itemList.length !== 0) {
            _.forEach(itemList, function (item) {
                if (item.quantity !== '0') {
                    updatedList.push(item);
                }
            });
        }
        return updatedList;
    },

    removeHashKey: function removeHashKey(shoppingCart) {
        _.forEach(shoppingCart.items, function (item) {
            if (item.item_option_selections) {
                _.forEach(item.item_option_selections, function (option, index) {
                    if (option.$$hashKey) {
                        delete option.$$hashKey;
                    }
                });
            }
        });
    },

    getCartItemsTotal: function getCartItemsTotal(itemsInCart) {
        return addItemAmounts(itemsInCart);
    },

    areAllItemsZeroPriced: function areAllItemsZeroPriced(itemsInCart) {
        if (!itemsInCart || itemsInCart.length === 0) {
            return false;
        }
        var item = void 0;
        for (var i = 0; i < itemsInCart.length; i++) {
            item = itemsInCart[i];
            if (+item.price !== 0) {
                return false;
            }
        }
        return true;
    },

    getItemsForShippingCalculation: function getItemsForShippingCalculation(itemsInCart) {
        var items = [];
        _.forEach(itemsInCart, function (cartItem, index) {
            var item = {};
            item.quantity = cartItem.quantity;
            if (item.quantity && item.quantity !== '0') {
                item.sku = cartItem.sku;
                item.name = cartItem.name;
                item.price = {
                    amount: cartItem.price,
                    currency_code: cartItem.currency
                };
                if (cartItem.shipping_cost) {
                    item.shipping = {
                        amount: cartItem.shipping_cost,
                        currency_code: cartItem.currency
                    };
                }
                if (cartItem.handling_cost) {
                    item.handling = {
                        amount: cartItem.handling_cost,
                        currency_code: cartItem.currency
                    };
                }
                if (cartItem.weight) {
                    item.weight = cartItem.weight;
                }
                items.push(item);
            }
        });
        return items;
    },

    buttonItemHasPrice: function buttonItemHasPrice(buttonData) {
        if (buttonData.buttonItem && buttonData.buttonItem.items && buttonData.buttonItem.items[0]) {
            return buttonData.buttonItem.items[0].price !== undefined;
        }
        return false;
    },

    decideShoppingUrl: function decideShoppingUrl(result, previousPageUrl) {
        if (!result) {
            return;
        }

        // extract shoppingCart resource urls for local use
        var shoppingCartUrls = result && result.shoppingCart && result.shoppingCart.urls;

        // check for shoppingURL either from result or result.shoppingCart
        var shoppingURL = result.shoppingUrl || shoppingCartUrls && shoppingCartUrls.shopping_url;

        // if shopping url not passed by merchant, then look for cancel url
        var cancelURL = shoppingCartUrls && shoppingCartUrls.cancel_url;

        // if cancel url not passed by merchant, then look for return url
        var returnURL = shoppingCartUrls && shoppingCartUrls.return_url;

        // and the priority is shoppingURL or previousPageUrl or returnURL
        return shoppingURL || previousPageUrl || cancelURL || returnURL;
    },

    // return true if url has a xss attack
    isUnsafeRedirect: function isUnsafeRedirect(url) {
        return _.isString(url) && (url.toLowerCase().replace(/\s/g, '').indexOf('javascript:') !== -1 || // eslint-disable-line no-script-url
        url.toLowerCase().replace(/\s/g, '').indexOf('data:') !== -1);
    }
};

// shipping value should not be modified if shiptaxcalcserv service is not called, that is profile shipping is missing.
/**
 * no_shipping = 1, profile_override = false => no shipping applied
 * no_shipping = 1, profile_override = true => shipping from button
 * no_shipping = 0/2/undefined, profile_override = true => shipping from service response
 * no_shipping = 0/2/undefined, profile_override = false => shipping from service response
 */

var evaluateShipping = function evaluateShipping(shippingFromButton, shippingProfile) {
    var profileOverride = shippingProfile && shippingProfile.profileOverride;
    var noShippingParam = shippingProfile && shippingProfile.noShippingParam;
    if (noShippingParam === '1' && profileOverride === false) {
        return;
    } else if (noShippingParam !== '1' && shippingProfile && !isNaN(shippingProfile.value)) {
        return shippingProfile.value;
    }
    return shippingFromButton;
};

var sumCharge = function sumCharge(sum, value) {
    if (value !== undefined) {
        if (sum === undefined) {
            sum = 0;
        }
        sum = Number(sum) + Number(value);
    }
    return sum;
};

var addCharge = function addCharge(additionalCharges, name, value) {
    if (value !== undefined) {
        if (additionalCharges === undefined) {
            additionalCharges = [];
        }
        additionalCharges.push({ name: name, value: value });
    }
    return additionalCharges;
};

var replacePlus = function replacePlus(jsonParams) {
    var modifiedVal = void 0; // value after replacing + with ' '
    var modifiedParams = {};
    for (var key in jsonParams) {
        if (jsonParams.hasOwnProperty(key)) {
            if (jsonParams[key]) {
                modifiedVal = jsonParams[key].replace(/\+/g, ' ');
                if (jsonParams[key] !== modifiedVal) {
                    modifiedParams[key] = { orig: jsonParams[key], 'new': modifiedVal };
                    jsonParams[key] = modifiedVal;
                }
            }
        }
    }
    if (modifiedParams) {
        _logger.$logger.info('ITEM_OPTIONS_PARAMS_MODIFIED');
    }
    return jsonParams;
};

var mapItemOptionSelectionParams = function mapItemOptionSelectionParams(buttonParams, jsonParams, retryAttempt) {
    var regexVar = {
        onX: { name: 'on', maxIndex: 29 },
        osX: { name: 'os', maxIndex: 29 },
        optionAmountSelection: { name: 'option_amount_selection', maxIndex: 29 },
        optionAmount: { name: 'option_amount', maxIndex: 29 },
        optionSelect: { name: 'option_select', maxIndex: 29 },
        optionItemNumber: { name: 'option_item_number', maxIndex: 29 }
    };

    var optionAmountIndex = jsonParams['option_amount_index'] || jsonParams['option_index'] || 0;
    var optionIndex = jsonParams['option_index'] || 0;
    // reset item_option_selections in case of second mapping attempt
    if (retryAttempt && buttonParams.items[0].item_option_selections) {
        buttonParams.items[0].item_option_selections = [];
    }
    for (var i = 0; i < regexVar.onX.maxIndex; i += 1) {
        var on = '' + regexVar.onX.name + i;
        var os = '' + regexVar.osX.name + i;

        var option = void 0;
        var optionBasedParams = void 0;
        if (jsonParams[on] || jsonParams[os]) {
            option = { name: jsonParams[on] };
            if (jsonParams[os]) {
                option['select'] = jsonParams[os];
                if (+optionAmountIndex === i) {
                    optionBasedParams = selectAmountFromOption(os, jsonParams, regexVar);
                    if (optionBasedParams.amount && (0, _validators.isValidAmount)(optionBasedParams.amount.value)) {
                        // Set the amount in the item's top level price.
                        buttonParams.items[0].price = (0, _util.formatValue)(optionBasedParams.amount.value, 2);
                    }
                }
                if (+optionIndex === i) {
                    optionBasedParams = selectItemIdFromOption(os, jsonParams, regexVar);
                    if (optionBasedParams.item_number) {
                        buttonParams.items[0].sku = optionBasedParams.item_number;
                    }
                }
            } else {
                option['select'] = '-';
            }
        }

        // set the option only when option name is present or else ignore
        if (option && option.name) {
            buttonParams.items[0].item_option_selections = buttonParams.items[0].item_option_selections || [];
            buttonParams.items[0].item_option_selections.push(option);
        }
    }

    if (!buttonParams.items[0].price) {
        if (!retryAttempt) {
            mapItemOptionSelectionParams(buttonParams, replacePlus(jsonParams), true);
        }
    }

    return buttonParams;
};

var selectAmountFromOption = function selectAmountFromOption(os, jsonParams, regexVar) {
    var amount = void 0;

    for (var i = 0; i <= regexVar.optionAmount.maxIndex; i += 1) {
        var optionAmountSelection = '' + regexVar.optionAmountSelection.name + i;
        var optionSelect = '' + regexVar.optionSelect.name + i;
        var optionAmount = '' + regexVar.optionAmount.name + i;

        // The first match of many option_selectZ's matching always wins
        if (!jsonParams[optionAmountSelection]) {
            jsonParams[optionAmountSelection] = jsonParams[optionSelect];
        }

        if (jsonParams[os] === jsonParams[optionAmountSelection]) {
            if ((0, _validators.isValidAmount)(jsonParams[optionAmount])) {
                amount = {};
                amount.value = (0, _util.formatValue)(jsonParams[optionAmount], 2);
                amount.currency = (0, _util.getCurrencyCode)(jsonParams['currency_code']);
            }
            break; // First match wins even if option_amount not present!
        }
    }

    var params = {
        amount: amount
    };
    return params;
};

var selectItemIdFromOption = function selectItemIdFromOption(os, jsonParams, regexVar) {
    var itemId = void 0;

    for (var i = 0; i <= regexVar.optionSelect.maxIndex; i += 1) {
        var optionSelect = '' + regexVar.optionSelect.name + i;
        var optionItemNumber = '' + regexVar.optionItemNumber.name + i;

        // The first match of many option_selectZ's matching always wins
        if (jsonParams[os] === jsonParams[optionSelect]) {
            if (jsonParams[optionItemNumber]) {
                itemId = jsonParams[optionItemNumber];
            }
            break; // First match wins even if option_amount not present!
        }
    }
    var params = {
        item_number: itemId
    };
    return params;
};

var addItemAmounts = function addItemAmounts(itemsInCart) {
    if (!itemsInCart) {
        return;
    }
    var sum = 0;
    _.forEach(itemsInCart, function (item) {
        sum += item.removed ? 0 : item.price * item.quantity;
    });
    return sum;
};

_validators.isValidAmount;

_util.getCurrencyCode;

_util.formatValue;

_constants.XCLICK_VARS;

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-shoppingcart/cartUtil.js
// module id = ./pages/xo-shoppingcart/cartUtil.js
// module chunks = 0